import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import ProductButton from '../../components/ProductButton';
import { EmotionBreakpoint } from 'dw-us-ui';

// Styled Components
// ${EmotionBreakpoint('tablet')} {
// ${EmotionBreakpoint('mobile')} {
const SectionContainer = styled.div`
	background: #f1f1f1;
	height: auto;
	padding-bottom: 40px;
	.law & {
		background: #f8f5ef;
	}
	.bon & {
		background: #f9fafb;
	}
	.osw & {
		background: #f8f5ef;
	}
	.npr & {
		background: #ededed;
	}
	${EmotionBreakpoint('mobile')} {
		padding-bottom: 0px;
		padding-top: 0px;
	}
	${EmotionBreakpoint('tablet')} {
		padding-bottom: 0px;
	}

	.case-tab-selector-button-container {
		display: flex;
		flex-direction: row;
		gap: 12px;
		justify-content: center; /* Center buttons on larger screens */
		padding: 0px 112px;
		overflow-x: auto;
		scroll-behavior: smooth;
		scroll-snap-type: x mandatory; /* Enables smooth snap scrolling */
		scrollbar-width: none; /* Hides scrollbar */

		.active-tab {
			scroll-snap-align: center; /* Ensures active tab centers */
		}

		${EmotionBreakpoint('mobile')} {
			flex-direction: row;
			width: 100%;
			padding: 0px;
			overflow-x: auto;
			white-space: nowrap;
			scrollbar-width: none;
			gap: 0px;
			justify-content: flex-start; /* Prevents spacing issues on mobile */
		}

		${EmotionBreakpoint('tablet')} {
			flex-direction: row;
			width: 100%;
			padding: 0px;
			overflow-x: auto;
			white-space: nowrap;
			scrollbar-width: none;
			gap: 0px;
			justify-content: flex-start;
		}
	}
`;

const TitleContainer = styled.div`
	display: flex;
	height: 104px;
	padding: 40px 112px 0 112px;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	${EmotionBreakpoint('mobile')} {
		padding: 36px 16px 16px;
		justify-content: center;
		align-items: center;
	}
	${EmotionBreakpoint('tablet')} {
		padding: 36px 16px 16px;
		justify-content: center;
		align-items: center;
	}
`;

const Title = styled.h2`
	color: #2b2a2f;
	text-align: center;
	font-family: 'Escrow Banner Compressed', sans-serif;
	font-size: 40px;
	font-style: normal;
	font-weight: 500;
	line-height: 112%;
	.fox & {
		color: var(--Base-Colors-Black, #222);
		text-align: center;
		/* Fox/Desktop/H2 */
		font-family: Roboto;
		font-size: 34px;
		font-style: normal;
		font-weight: 900;
		line-height: 105%; /* 35.7px */
		letter-spacing: -1.02px;
		text-transform: none;
	}
	.bon & {
		color: var(--Base-Colors-Black, #222);
		text-align: center;
		font-family: 'FuturaPT';
		font-size: 32px;
		font-style: normal;
		font-weight: 600;
		line-height: 40px; /* 125% */
		letter-spacing: 1.28px;
		text-transform: uppercase;
	}
	.law & {
		font-family: 'Oswald';
		text-transform: uppercase;
	}
	.osw & {
		font-family: 'Neue Aachen Pro';
	}
	.npr & {
		font-family: 'Gotham';
	}
	.wsj & {
		text-transform: uppercase;
	}
	${EmotionBreakpoint('mobile')} {
		color: #2b2a2f;
		text-align: center;
		font-family: 'Escrow Banner Compressed', sans-serif;
		font-size: 32px;
		font-style: normal;
		font-weight: 500;
		line-height: 32px;
		text-transform: uppercase;
		.fox & {
			font-family: Roboto;
			text-transform: none;
		}
		.law & {
			font-family: 'Oswald';
		}
		.osw & {
			font-family: 'Neue Aachen Pro';
			font-size: 32px;
		}
		.npr & {
			font-family: 'Gotham';
		}
	}
	${EmotionBreakpoint('tablet')} {
		color: #2b2a2f;
		text-align: center;
		font-family: 'Escrow Banner Compressed', sans-serif;
		font-size: 32px;
		font-style: normal;
		font-weight: 500;
		line-height: 32px;
		text-transform: uppercase;
		.fox & {
			font-family: Roboto;
			text-transform: none;
		}
		.law & {
			font-family: 'Oswald';
		}
		.osw & {
			font-family: 'Neue Aachen Pro';
		}
		.npr & {
			font-family: 'Gotham';
		}
	}
`;

const TabWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 10px;
	flex: 1 0 0;
	padding: 16px 20px;
	text-transform: uppercase;
	color: ${({ isActive }) => (isActive ? '#2B2A2F' : '#BCBCBC')};
	border-bottom: ${({ isActive }) =>
		isActive ? '2px solid #2B2A2F' : '2px solid #F1F1F1'};
	font-family: Arial, sans-serif;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 20px; /* 142.857% */
	letter-spacing: 2px;
	cursor: pointer;
	.fox & {
		font-family: Roboto;
	}
	.bon & {
		font-family: 'FuturaPT';
		font-size: 18px;
		color: ${({ isActive }) => (isActive ? '#000' : '#666')};
	}
	.law & {
		font-family: Roboto;
		font-weight: 600;
	}
	.osw & {
		font-family: Roboto;
		font-weight: 600;
	}
	.npr & {
		font-family: Roboto;
		font-weight: 600;
	}
`;

const HorizontalLine = styled.hr`
	display: flex;
	width: 100%;
	padding: 0px;
	align-items: flex-start;
	border: none;
	border-bottom: 1px solid #bcbcbc;
	margin: 0;
`;

const CarouselContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-top: 50px;
	text-align: center;
	${EmotionBreakpoint('mobile')} {
		padding: 24px 16px 32px 16px;
		margin-top: 0px;
	}
	${EmotionBreakpoint('tablet')} {
		padding: 24px 16px 32px 16px;
		margin-top: 0px;
	}

	.carousel-navigation {
		display: flex;
		justify-content: space-between;
		align-items: center;
		max-width: 100%; /* Prevent overflow */
		overflow-x: hidden;
		.mobile-svg-previous {
			display: none;
		}
		.mobile-svg-next {
			display: none;
		}

		${EmotionBreakpoint('tablet')} {
			width: 100%;
		}

		.desktop-svg {
			max-width: 100%;
			height: auto;
			object-fit: contain;
			box-sizing: border-box;
		}

		${EmotionBreakpoint('mobile')} {
			margin: 0;
			flex-direction: row;
			width: 100%;
			.mobile-svg-previous {
				display: none;
			}
			.mobile-svg-next {
				display: none;
			}
			.desktop-svg {
				display: block;
			}
		}
		${EmotionBreakpoint('tablet')} {
			margin: 0;
			flex-direction: row;
			width: 100%;
			.mobile-svg-previous {
				display: none;
			}
			.mobile-svg-next {
				display: none;
			}
			.desktop-svg {
				display: block;
			}
		}

		img {
			height: 40px;
			cursor: pointer;
		}

		img,
		svg {
			max-width: 100%;
			height: auto;
			box-sizing: border-box;
		}
	}

	.product-details-wrapper {
		flex: 1 1 0%;
		text-align: center;
		width: 90%;
	}
`;

const Pagination = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 12px;
	margin-right: 5px;
	padding-left: 34.8%;
	flex-wrap: nowrap;
	overflow-x: auto;
	direction: ltr;
	margin-top: 20px;
	${EmotionBreakpoint('mobile')} {
		display: none;
	}
	${EmotionBreakpoint('tablet')} {
		display: none;
	}

	.pagination-button {
		background: #ffffff;
		border: 1 px solid #222222;
		border-color: #2222;
		border-radius: 4px;
		cursor: pointer;
		font-size: 18px;
		width: 40px;
		height: 40px;
		padding: 0px;
		margin-bottom: 0px;
		border: 1px solid;
		.fox & {
			padding: 12px;
		}
		.bon & {
			img {
				margin-left: 12px;
			}
		}

		img {
			height: 15px;
			padding: 0px;
		}
	}

	.page-number {
		width: 32px;
		height: 32px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 16px;
		cursor: pointer;
		color: #2b2a2f;
		padding-top: 3px;
		.fox & {
			border-radius: var(--Borders-Radius-Default, 4px);
			border: 1px solid var(--Fox-Primary-Blue-500, #2954b6);
			background: var(--Fox-Base-White, #fff);
			color: #2954b6;
			padding-top: 4px;
			width: 40px;
			height: 40px;
			font-weight: 500;
		}

		.bon & {
			border-radius: var(--Borders-Radius-Default, 4px);
			border: 1px solid var(--Base-Colors-Black, #222);
			background: var(--BA-Primary-White, #fff);
			width: 40px;
			height: 40px;
			font-weight: 700;
		}

		&.active {
			background-color: #767676;
			color: #fff;
			border-color: #2b2a2f;
			border-radius: 4px;
			padding-top: 3px;
			.fox & {
				border: 0.5px solid var(--Fox-Primary-Blue-500, #2954b6);
				background: var(--Fox-Primary-Blue-500, #2954b6);
				padding-top: 4px;
				width: 40px;
				height: 40px;
			}
			.bon & {
				border-radius: var(--Borders-Radius-Default, 4px);
				border: 0.5px solid var(--Base-Colors-Black, #222);
				background: var(--Base-Colors-Black, #222);
				padding-top: 4px;
				width: 40px;
				height: 40px;
				font-weight: 700;
			}

			.law & {
				border: 0.5px solid #cf004f;
				background: #cf004f;
				border-radius: 5px;
				padding-top: 4px;
				width: 40px;
				height: 40px;
			}
			.npr & {
				border: 0.5px solid #da252b;
				background: #da252b;
				border-radius: 5px;
				padding-top: 4px;
				width: 40px;
				height: 40px;
			}
			.osw & {
				border: 0.5px solid #767676;
				background: #767676;
				padding-top: 4px;
				width: 40px;
				height: 40px;
				border-radius: 5px;
			}
		}
	}
`;

const ProductDetails = styled.div`
	display: flex;
	text-align: center;
	flex-direction: column;
	justify-content: space-evenly;
	.svg-container {
		position: relative;
		width: 240px;
		height: 240px;
		.img-circle-wrapper {
			position: relative;
			display: inline-block;
		}
		${EmotionBreakpoint('mobile')} {
			width: auto;
			height: auto;
			display: flex;
			align-items: center;
			flex-direction: row;
			gap: 20px;
		}
		${EmotionBreakpoint('tablet')} {
			width: auto;
			height: auto;
			display: flex;
			align-items: center;
			flex-direction: row;
			gap: 20px;
		}
		mobile-svg-left {
			display: none;

			${EmotionBreakpoint('mobile')} {
				display: flex;
				flex-direction: column;
				justify-content: space-around;
			}
			${EmotionBreakpoint('tablet')} {
				display: flex;
				flex-direction: column;
				justify-content: space-around;
			}
		}
		mobile-svg-right {
			display: none;
			${EmotionBreakpoint('mobile')} {
				display: flex;
				flex-direction: column;
				justify-content: space-around;
			}
			${EmotionBreakpoint('tablet')} {
				display: flex;
				flex-direction: column;
				justify-content: space-around;
			}
		}
	}
	h3 {
		color: #2b2a2f;
		text-align: center;
		font-family: 'Escrow', 'Georgia', serif;
		font-size: 24px;
		font-style: normal;
		font-weight: 400;
		line-height: 28px;
		.fox & {
			color: var(--Base-Colors-Black, #222);
			text-align: center;
			/* Fox/Desktop/H6 */
			font-family: Roboto;
			font-size: 22px;
			font-style: normal;
			font-weight: 600;
			line-height: 120%;
			letter-spacing: -0.22px;
		}
		.bon & {
			color: var(--Base-Colors-Black, #222);
			text-align: center;
			font-family: 'FuturaPT';
			font-size: 26px;
			font-style: normal;
			font-weight: 500;
			line-height: 30px;
		}
		.law & {
			color: #222222;
			font-family: 'Noto Serif';
			font-size: 24px;
			font-weight: 600;
		}
		.osw & {
			color: #222222;
			font-family: 'Neue Aachen Pro';
			font-size: 24px;
			font-weight: 500;
		}
		.npr & {
			color: #222222;
			font-family: 'Gotham';
			font-size: 24px;
			font-weight: 600;
		}
	}
	.product-button-container {
		${EmotionBreakpoint('mobile')} {
			width: 100%;
		}
		${EmotionBreakpoint('tablet')} {
			width: 100%;
		}
	}
	.case-tabs-product-button {
		margin-left: 0px;
		.bon & {
			color: var(--BA-Primary-White, #fff);
			text-align: center;
			font-family: 'FuturaPT';
			font-size: 18px;
			font-style: normal;
			font-weight: 500;
			line-height: 22px;
			letter-spacing: 0.48px;
			text-transform: uppercase;
		}
		${EmotionBreakpoint('mobile')} {
			width: 100%;
		}
		${EmotionBreakpoint('tablet')} {
			width: 100%;
		}
	}

	.product-details-container {
		display: flex;
		flex-direction: row;
		gap: 40px;
		${EmotionBreakpoint('mobile')} {
			flex-direction: column;
			align-items: center;
			gap: ${({ shouldShowRating }) => (!shouldShowRating ? '60px' : '24px')};
		}
		${EmotionBreakpoint('tablet')} {
			flex-direction: column;
			align-items: center;
			gap: ${({ shouldShowRating }) => (!shouldShowRating ? '60px' : '24px')};
		}
	}

	.product-img-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 40px;
		width: 360px;
		height: 408px;
		${EmotionBreakpoint('mobile')} {
			width: 100%;
			height: 100%;
		}
		${EmotionBreakpoint('tablet')} {
			width: 100%;
			height: 100%;
		}

		img {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			z-index: 1;
			height: 300px;
			cursor: default;
		}
		.star-ratings {
			display: flex;
			justify-content: center;
			margin: 10px 0;
			gap: 4px;
			align-items: baseline;
			#half-rating-star {
				width: 16px;
				height: 16px;
				position: static;
				top: auto;
				left: auto;
				transform: none;
				z-index: auto;
			}
			.star-ratings-int {
				padding-left: 8px;
				color: #2b2a2f;
				text-align: center;
				font-family: Arial;
				font-size: 16px;
				font-style: normal;
				font-weight: 500;
				line-height: 24px;
				.fox & {
					font-family: Roboto;
				}
				.law & {
					font-family: Roboto;
				}
				.osw & {
					font-family: Roboto;
				}
				.npr & {
					font-family: Roboto;
				}
				.bon & {
					font-family: FuturaPT;
				}
			}
		}
	}
	.product-info-container {
		display: flex;
		width: 760px;
		height: auto;
		flex-direction: column;
		gap: 24px;
		align-items: flex-start;
		text-align: left;
		${EmotionBreakpoint('mobile')} {
			width: 100%;
			height: 100%;
		}
		${EmotionBreakpoint('tablet')} {
			width: 100%;
			height: 100%;
		}

		.wine-info {
			display: flex;
			flex-direction: row;
			gap: 20px;
			${EmotionBreakpoint('mobile')} {
				flex-direction: column;
				gap: 8px;
			}
			${EmotionBreakpoint('tablet')} {
				flex-direction: column;
				gap: 8px;
			}
		}
		.wine-description {
			max-width: 676px;
		}
		.fox & {
			.wine-description {
				font-size: 16px !important;
			}
			strong {
				font-family: 'Roboto';
				color: #222222;
				font-weight: 700;
			}
		}

		.bon & {
			.wine-description {
				font-size: 16px !important;
			}
			strong {
				font-family: 'FuturaPT';
				color: #222222;
				font-weight: 700;
			}
		}
		.wsj & {
			.wine-description {
				font-size: 16px !important;
				font-family: 'Arial';
			}
			strong {
				font-family: 'Arial';
				color: #2b2a2f;
				font-weight: 700;
			}
		}
		.law & {
			.wine-description {
				font-size: 16px !important;
				font-family: Roboto;
			}
			strong {
				font-family: 'Roboto';
				color: #222222;
				font-weight: 600;
			}
		}
		.osw & {
			.wine-description {
				font-size: 16px !important;
				font-family: Roboto;
			}
			strong {
				font-family: 'Roboto';
				color: #222222;
				font-weight: 600;
			}
		}
		.npr & {
			.wine-description {
				font-size: 16px !important;
				font-family: Roboto;
			}
			strong {
				font-family: 'Roboto';
				color: #222222;
				font-weight: 600;
			}
		}
		.wine-profile {
			display: flex;
			flex-direction: column;
			max-width: 676px;
			gap: 12px;
			.show-more {
				display: none;
			}
			${EmotionBreakpoint('mobile')} {
				.show-more {
					display: flex;
					flex-direction: row;
					gap: 8px;
					align-items: center;

					.show-more-text {
						color: #2b2a2f;
						text-align: center;
						font-family: Arial;
						font-size: 16px;
						font-style: normal;
						font-weight: 500;
						line-height: 24px;
						text-decoration-line: underline;
						text-decoration-style: solid;
						text-decoration-skip-ink: none;
						text-decoration-thickness: auto;
						text-underline-offset: auto;
						text-underline-position: from-font;
						.law & {
							font-family: Roboto;
							color: #2b2a2f;
							font-weight: 700;
						}
						.osw & {
							font-family: Roboto;
							color: #2b2a2f;
							font-weight: 700;
						}
						.npr & {
							font-family: Roboto;
							color: #2b2a2f;
							font-weight: 700;
						}
						.bon & {
							font-family: FuturaPT;
							color: #222;
							font-weight: 700;
						}
					}
				}
			}
			${EmotionBreakpoint('tablet')} {
				.show-more {
					display: flex;
					flex-direction: row;
					gap: 8px;
					align-items: center;

					.show-more-text {
						color: #2b2a2f;
						text-align: center;
						font-family: Arial;
						font-size: 16px;
						font-style: normal;
						font-weight: 500;
						line-height: 24px;
						text-decoration-line: underline;
						text-decoration-style: solid;
						text-decoration-skip-ink: none;
						text-decoration-thickness: auto;
						text-underline-offset: auto;
						text-underline-position: from-font;
						.fox & {
							font-family: Roboto;
						}
						.law & {
							font-family: Roboto;
							color: #2b2a2f;
							font-weight: 700;
						}
						.osw & {
							font-family: Roboto;
							color: #2b2a2f;
							font-weight: 700;
						}
						.npr & {
							font-family: Roboto;
							color: #2b2a2f;
							font-weight: 700;
						}
						.bon & {
							font-family: FuturaPT;
							color: #222;
							font-weight: 700;
							font-size: 16px;
						}
					}
				}
			}
		}
		.food-pairing {
			display: flex;
			flex-direction: column;
			max-width: 676px;
			gap: 12px;
			.show-more {
				display: none;
			}
			${EmotionBreakpoint('mobile')} {
				.show-more {
					display: flex;
					flex-direction: row;
					gap: 8px;
					align-items: center;

					.show-more-text {
						color: #2b2a2f;
						text-align: center;
						font-family: Arial;
						font-size: 16px;
						font-style: normal;
						font-weight: 500;
						line-height: 24px;
						text-decoration-line: underline;
						text-decoration-style: solid;
						text-decoration-skip-ink: none;
						text-decoration-thickness: auto;
						text-underline-offset: auto;
						text-underline-position: from-font;
						.law & {
							font-family: Roboto;
							color: #2b2a2f;
							font-weight: 700;
						}
						.osw & {
							font-family: Roboto;
							color: #2b2a2f;
							font-weight: 700;
						}
						.npr & {
							font-family: Roboto;
							color: #2b2a2f;
							font-weight: 700;
						}
						.bon & {
							font-family: FuturaPT;
							color: #222;
							font-weight: 700;
						}
					}
				}
			}
			${EmotionBreakpoint('tablet')} {
				.show-more {
					display: flex;
					flex-direction: row;
					gap: 8px;
					align-items: center;

					.show-more-text {
						color: #2b2a2f;
						text-align: center;
						font-family: Arial;
						font-size: 16px;
						font-style: normal;
						font-weight: 500;
						line-height: 24px;
						text-decoration-line: underline;
						text-decoration-style: solid;
						text-decoration-skip-ink: none;
						text-decoration-thickness: auto;
						text-underline-offset: auto;
						text-underline-position: from-font;
						.fox & {
							font-family: Roboto;
						}
						.law & {
							font-family: Roboto;
							color: #2b2a2f;
							font-weight: 700;
						}
						.osw & {
							font-family: Roboto;
							color: #2b2a2f;
							font-weight: 700;
						}
						.npr & {
							font-family: Roboto;
							color: #2b2a2f;
							font-weight: 700;
						}
						.bon & {
							font-family: FuturaPT;
							color: #222;
							font-weight: 700;
							font-size: 16px;
						}
					}
				}
			}
		}
		.info {
			flex: 1 1 50%;
			box-sizing: border-box;
			padding: 4px;
			margin: 0;
			text-align: left;
			width: 305px;
		}
		strong {
			color: #2b2a2f;
			font-family: Arial;
			font-size: 16px;
			font-style: normal;
			font-weight: 500;
			line-height: 24px;
			.fox & {
				font-family: Roboto;
			}
			.law & {
				font-family: Roboto;
				font-weight: 600;
			}
			.osw & {
				font-family: Roboto;
				font-weight: 600;
			}
			.npr & {
				font-family: Roboto;
				font-weight: 600;
			}
			.bon & {
				font-family: 'FuturaPT';
				font-weight: 700;
			}
		}
		p {
			color: #2b2a2f;
			font-family: Arial;
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 24px; /* 150% */
			.fox & {
				font-family: Roboto;
			}
			.law & {
				font-family: Roboto;
			}
			.osw & {
				font-family: Roboto;
			}
			.npr & {
				font-family: Roboto;
			}
			.bon & {
				font-family: 'FuturaPT';
				font-size: 16px;
			}
		}
	}
`;

const QuantityBadge = styled.div`
	position: absolute;
	top: 2px;
	right: 32px;
	width: 45px;
	height: 45px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${({ brandTag }) =>
		brandTag === 'fox'
			? '#BC212F'
			: brandTag === 'wsj'
			? '#E92440'
			: brandTag === 'law'
			? '#CF004F'
			: brandTag === 'bon'
			? '#8B1F41'
			: brandTag === 'law'
			? '#CF004F'
			: brandTag === 'osw'
			? '#CC2127'
			: brandTag === 'npr'
			? '#237BBD'
			: '#C41230'};
	color: #ffffff;
	font-family: Arial, sans-serif;
	font-size: 20px;
	font-style: normal;
	font-weight: 700;
	line-height: 1;
	z-index: 2;
	.fox & {
		font-family: Roboto;
	}
	.bon & {
		font-family: 'FuturaPT';
	}
	.law & {
		font-family: Roboto;
	}
	.osw & {
		font-family: Roboto;
	}
	.npr & {
		font-family: Roboto;
	}
`;

const HalfStar = ({ keyProp, brandTag }) =>
	brandTag === 'fox' || brandTag === 'bon' ? (
		<img
			src='/images/us/fox/common/icons/half-rating-star.svg'
			id='half-rating-star'
			alt='half-rating-star'
			key={keyProp}
		/>
	) : (
		<img
			src='https://www.wsjwine.com/images/us/wsj/common/icons/half-rating-star.svg'
			id='half-rating-star'
			alt='half-rating-star'
			key={keyProp}
		/>
	);

const FilledStar = ({ keyProp, brandTag }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='16'
		height='16'
		viewBox='0 0 16 16'
		fill='none'
		key={keyProp}
	>
		<path
			d='M7.14486 0.86206L5.19196 4.82168L0.822626 5.45869C0.0390758 5.57233 -0.274942 6.53831 0.293281 7.09158L3.4544 10.1719L2.70673 14.5233C2.57216 15.3099 3.40057 15.899 4.0944 15.5312L8.00317 13.4766L11.912 15.5312C12.6058 15.896 13.4342 15.3099 13.2996 14.5233L12.552 10.1719L15.7131 7.09158C16.2813 6.53831 15.9673 5.57233 15.1837 5.45869L10.8144 4.82168L8.86149 0.86206C8.51159 0.156267 7.49775 0.147295 7.14486 0.86206Z'
			fill={
				brandTag === 'fox' || brandTag === 'bon'
					? '#FBBF24'
					: brandTag === 'wsj'
					? '#F7AB89'
					: brandTag === 'law'
					? '#B79178'
					: brandTag === 'osw'
					? '#E06729'
					: '#EE8145'
			}
		/>
	</svg>
);

const EmptyStar = ({ keyProp, brandTag }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='17'
		height='16'
		viewBox='0 0 17 16'
		fill='none'
		key={keyProp}
	>
		<g clip-path='url(#clip0_557_2350)'>
			<path
				d='M5.78213 5.44014L6.10719 5.39275L6.2525 5.09814L8.20527 1.13875C8.32563 0.894975 8.67777 0.890573 8.80139 1.13939C8.80144 1.13948 8.80148 1.13958 8.80153 1.13967L10.7539 5.09813L10.8992 5.39275L11.2242 5.44014L15.5936 6.07715L15.594 6.07722C15.8643 6.11641 15.9743 6.45176 15.7771 6.64379L15.7769 6.64396L12.6158 9.72433L12.3803 9.95377L12.436 10.2778L13.1836 14.6287C13.2294 14.8964 12.9458 15.1058 12.7028 14.978L12.7027 14.978L8.79397 12.9234L8.50317 12.7705L8.21238 12.9234L4.3036 14.978L4.30164 14.979C4.06304 15.1055 3.77633 14.9002 3.82278 14.6287L4.57037 10.2778L4.62604 9.95377L4.39058 9.72433L1.22947 6.64396L1.22929 6.64379C1.03208 6.45176 1.1421 6.11641 1.41234 6.07722L1.41279 6.07715L5.78213 5.44014Z'
				stroke={
					brandTag === 'fox' || brandTag === 'bon'
						? '#FBBF24'
						: brandTag === 'wsj'
						? '#F7AB89'
						: brandTag === 'law'
						? '#B79178'
						: brandTag === 'osw'
						? '#E06729'
						: '#EE8145'
				}
				stroke-width='1.25'
			/>
		</g>
		<defs>
			<clipPath id='clip0_557_2350'>
				<rect width='16' height='16' fill='white' transform='translate(0.5)' />
			</clipPath>
		</defs>
	</svg>
);

const renderStars = (rating, brandTag) => {
	if (isNaN(rating) || rating === undefined || rating < 0 || rating > 5) {
		console.error('Invalid rating:', rating);
		return [];
	}

	const totalStars = 5;
	const stars = [];
	const fullStars = Math.floor(rating);
	const fractionalPart = Math.round((rating - fullStars) * 10) / 10;

	for (let i = 0; i < fullStars; i++) {
		stars.push(<FilledStar key={i} brandTag={brandTag} />);
	}

	if (fractionalPart >= 0.1 && fractionalPart <= 0.5) {
		stars.push(<HalfStar key={fullStars} brandTag={brandTag} />);
	} else if (fractionalPart > 0.5 && fractionalPart < 1) {
		stars.push(<FilledStar key={fullStars} brandTag={brandTag} />);
	}

	const remainingStars = totalStars - stars.length;
	for (let i = 0; i < remainingStars; i++) {
		stars.push(<EmptyStar key={fullStars + i} brandTag={brandTag} />);
	}

	return stars;
};

const CaseTabsSection = ({
	contentfulData,
	products,
	activeProductIndex,
	setActiveProductIndex,
	setActiveProduct,
	caseData,
	brandTag,
	isPresell,
}) => {
	const {
		productCodes = [],
		customProductTitles = [],
		voucherCopy = [],
	} = contentfulData || {};
	const [isExpanded, setIsExpanded] = useState(false);
	const [currentSubProductIndex, setCurrentSubProductIndex] = useState(0);
	const [apiProductsData, setApiProductsData] = useState([]);
	const [comparisonResults, setComparisonResults] = useState([]);
	const [areAllProductsSame, setAreAllProductsSame] = useState(false);
	const itemsPerPage = 5;

	// Function to fetch all product data from API
	const fetchAllProductsData = async (productCodes) => {
		try {
			const fetchPromises = productCodes.map((code) =>
				fetch(`/api/product/case/${code}`)
					.then((response) => response.json())
					.catch((error) => {
						console.error(`Error fetching product ${code}:`, error);
						return null;
					})
			);

			const results = await Promise.all(fetchPromises);
			return results.filter((result) => result !== null);
		} catch (error) {
			console.error('Error fetching products data:', error);
			return [];
		}
	};

	// Function to compare content products with SKU IDs
	const compareContentProducts = (apiProducts, currentCaseData) => {
		if (!currentCaseData?.contentProducts) return [];

		const comparisons = apiProducts.map((apiProduct, index) => {
			if (!apiProduct?.response?.contentProducts) return null;

			const apiContentProducts = apiProduct.response.contentProducts;
			const caseContentProducts = currentCaseData.contentProducts;

			// Compare SKU IDs
			const matchedProducts = [];
			const unmatchedProducts = [];

			apiContentProducts.forEach((apiProd) => {
				const match = caseContentProducts.find(
					(caseProd) => caseProd.skuItemCode === apiProd.skuItemCode
				);

				if (match) {
					matchedProducts.push({
						skuItemCode: apiProd.skuItemCode,
						skuId: apiProd.skuId,
						productName: apiProd.referencedProduct?.name,
						matched: true,
					});
				} else {
					unmatchedProducts.push({
						skuItemCode: apiProd.skuItemCode,
						skuId: apiProd.skuId,
						productName: apiProd.referencedProduct?.name,
						matched: false,
					});
				}
			});

			return {
				productCode: productCodes[index],
				totalApiProducts: apiContentProducts.length,
				totalCaseProducts: caseContentProducts.length,
				matchedProducts,
				unmatchedProducts,
			};
		});

		return comparisons.filter((c) => c !== null);
	};

	// Function to check if all products have identical content products
	const checkIfAllProductsSame = (apiData) => {
		if (!apiData || apiData.length <= 1) {
			return false; // If only one product or no data, don't hide tabs
		}

		// Get the first product's content products as reference
		const firstProductSkus =
			apiData[0]?.response?.contentProducts
				?.map((cp) => cp.skuItemCode)
				.sort() || [];

		if (firstProductSkus.length === 0) {
			return false;
		}

		// Compare all other products with the first one
		for (let i = 1; i < apiData.length; i++) {
			const currentProductSkus =
				apiData[i]?.response?.contentProducts
					?.map((cp) => cp.skuItemCode)
					.sort() || [];

			// Check if lengths are different
			if (firstProductSkus.length !== currentProductSkus.length) {
				return false;
			}

			// Check if all SKUs match
			for (let j = 0; j < firstProductSkus.length; j++) {
				if (firstProductSkus[j] !== currentProductSkus[j]) {
					return false;
				}
			}
		}

		return true; // All products have identical content products
	};

	// Effect to fetch and compare data when productCodes change
	useEffect(() => {
		if (productCodes && productCodes.length > 0) {
			fetchAllProductsData(productCodes).then((apiData) => {
				setApiProductsData(apiData);
				const results = compareContentProducts(apiData, caseData);
				setComparisonResults(results);

				// Check if all products are the same
				const allSame = checkIfAllProductsSame(apiData);
				setAreAllProductsSame(allSame);

				// Log comparison results for debugging
				console.log('API Products Data:', apiData);
				console.log('Comparison Results:', results);
				console.log('Are all products same?', allSame);
			});
		}
	}, [productCodes, caseData]);

	// Filter valid products FIRST - this is the key fix
	// Exclude 'nonfoodsundry' and 'literature' product types from display
	const validContentProducts =
		caseData?.contentProducts?.filter(
			(subProduct) =>
				subProduct?.referencedProduct?.productType !== 'nonfoodsundry' &&
				subProduct?.referencedProduct?.productType !== 'literature'
		) || [];

	// Use filtered array length for total pages calculation
	const totalPages = validContentProducts.length;

	const toggleProfile = () => {
		setIsExpanded(!isExpanded);
	};

	useEffect(() => {
		setCurrentSubProductIndex(0);
	}, [caseData]);

	const handleNextSubProduct = () => {
		// Use validContentProducts.length instead of totalPages
		if (currentSubProductIndex + 1 < validContentProducts.length) {
			const newIndex = currentSubProductIndex + 1;

			setCurrentSubProductIndex(newIndex);
		} else {
			console.error('Cannot go to next - at boundary');
		}
	};

	const handlePreviousSubProduct = () => {
		if (currentSubProductIndex - 1 >= 0) {
			const newIndex = currentSubProductIndex - 1;

			setCurrentSubProductIndex(newIndex);
		} else {
			console.error('Cannot go to previous - at boundary');
		}
	};

	// Calculate the range of pages to display (5 at a time)
	const startPage = Math.max(currentSubProductIndex - 2, 0);
	const endPage = Math.min(
		startPage + itemsPerPage,
		validContentProducts.length
	); // Use validContentProducts.length

	// Render page numbers for the current range
	const pageNumbers = [];
	for (let i = startPage; i < endPage; i++) {
		pageNumbers.push(
			<div
				key={i}
				className={`page-number ${
					i === currentSubProductIndex ? 'active' : ''
				}`}
				onClick={() => {
					setCurrentSubProductIndex(i);
				}}
			>
				{i + 1}
			</div>
		);
	}

	// Now we can safely use the index without clamping issues
	const activeSubProduct = validContentProducts[currentSubProductIndex] || null;
	const bottleQuantity = activeSubProduct?.quantity || 1;
	const tastingNoteShort =
		activeSubProduct?.referencedProduct?.tastingNotes?.shortTastingNotesTaste ||
		'';
	const foodPairing =
		activeSubProduct?.referencedProduct?.tastingNotes?.shortTastingNotesAroma ||
		'';
	const isMobile = window.innerWidth <= 768;

	const rating =
		activeSubProduct?.referencedProduct?.productRating?.productRating
			?.avgRating || 0;
	const shouldShowRating = rating >= 3.5;
	return (
		<SectionContainer id='case-details-main-container'>
			<TitleContainer>
				<Title className='case-title'>What's in the Case?</Title>
			</TitleContainer>
			<div className='case-tab-selector-button-container'>
				{(productCodes?.length === 1 &&
					products[activeProductIndex]?.mixed === false) ||
				caseData?.contentProducts?.length <= 1 ? null : areAllProductsSame ? (
					// Show only first tab if all products have identical content
					<TabWrapper
						key={productCodes[0]}
						isActive={true}
						className='active-tab'
						onClick={(e) => {
							setActiveProductIndex(0);
							setActiveProduct(products[0]);
							window.dispatchEvent(
								new CustomEvent('checkoutOptionSelected', {
									detail: { index: 0, itemCode: products[0].itemCode },
								})
							);
							e.currentTarget.scrollIntoView({
								behavior: 'smooth',
								inline: 'center',
								block: 'nearest',
							});
						}}
					>
						{customProductTitles[0] || 'Product 1'}
					</TabWrapper>
				) : (
					productCodes?.map((code, index) => (
						// Show all tabs if products have different content
						<TabWrapper
							key={code}
							isActive={index === activeProductIndex}
							className={index === activeProductIndex ? 'active-tab' : ''}
							onClick={(e) => {
								setActiveProductIndex(index);
								setActiveProduct(products[index]);
								window.dispatchEvent(
									new CustomEvent('checkoutOptionSelected', {
										detail: { index, itemCode: products[index].itemCode },
									})
								);
								e.currentTarget.scrollIntoView({
									behavior: 'smooth',
									inline: 'center',
									block: 'nearest',
								});
							}}
						>
							{`${customProductTitles[index] || `Product ${index + 1}`}`}
						</TabWrapper>
					))
				)}
			</div>
			<HorizontalLine />
			<CarouselContainer>
				<div className='carousel-navigation'>
					{products[activeProductIndex]?.mixed === true &&
						caseData?.contentProducts?.length > 1 && (
							<svg
								onClick={handlePreviousSubProduct}
								xmlns='http://www.w3.org/2000/svg'
								width='40'
								height='40'
								viewBox='0 0 40 40'
								fill='none'
								style={{ cursor: 'pointer', marginBottom: '100px' }}
								className='desktop-svg'
							>
								<g clipPath='url(#clip0_557_2337)'>
									<path
										fillRule='evenodd'
										clipRule='evenodd'
										d='M29.1999 40L9.19995 20L29.1999 0L30.7973 1.59734L12.3946 20L30.7973 38.4027L29.1999 40Z'
										fill='#2B2A2F'
									/>
								</g>
								<defs>
									<clipPath id='clip0_557_2337'>
										<rect width='40' height='40' fill='white' />
									</clipPath>
								</defs>
							</svg>
						)}
					<div className='product-details-wrapper'>
						{activeSubProduct ? (
							<>
								<ProductDetails
									shouldShowRating={shouldShowRating}
									brandTag={brandTag}
								>
									<div className='product-details-container'>
										<div className='product-img-container'>
											<h3>
												{activeSubProduct?.referencedProduct?.name}{' '}
												{activeSubProduct?.referencedProduct?.vintage}
											</h3>
											<div className='svg-container'>
												<div className='mobile-svg-left'>
													<svg
														onClick={handlePreviousSubProduct}
														xmlns='http://www.w3.org/2000/svg'
														width='40'
														height='40'
														viewBox='0 0 40 40'
														fill='none'
														style={{ cursor: 'pointer' }}
														className='mobile-svg-previous'
													>
														<g clipPath='url(#clip0_557_2337)'>
															<path
																fillRule='evenodd'
																clipRule='evenodd'
																d='M29.1999 40L9.19995 20L29.1999 0L30.7973 1.59734L12.3946 20L30.7973 38.4027L29.1999 40Z'
																fill='#2B2A2F'
															/>
														</g>
														<defs>
															<clipPath id='clip0_557_2337'>
																<rect width='40' height='40' fill='white' />
															</clipPath>
														</defs>
													</svg>
												</div>

												<div className='img-circle-wrapper'>
													<svg
														xmlns='http://www.w3.org/2000/svg'
														width='240'
														height='240'
														viewBox='0 0 240 240'
														fill='none'
													>
														<circle
															cx='120'
															cy='120'
															r='120'
															fill={
																brandTag === 'fox'
																	? '#D4DDF0'
																	: brandTag === 'bon'
																	? '#F2F2F8'
																	: 'white'
															}
														/>
													</svg>

													<img
														src={`https://www.wsjwine.com/images/us/en/product/${activeSubProduct?.referencedProduct?.itemCode}.png`}
														alt={activeSubProduct?.referencedProduct?.name}
													/>

													{bottleQuantity > 0 && (
														<QuantityBadge brandTag={brandTag}>
															x{bottleQuantity}
														</QuantityBadge>
													)}
												</div>
												<div className='mobile-svg-right'>
													<svg
														onClick={handleNextSubProduct}
														xmlns='http://www.w3.org/2000/svg'
														width='40'
														height='40'
														viewBox='0 0 40 40'
														fill='none'
														style={{ cursor: 'pointer' }}
														className='mobile-svg-next'
													>
														<path
															fillRule='evenodd'
															clipRule='evenodd'
															d='M10.7973 0L30.7973 20L10.7973 40L9.19995 38.4027L27.6026 20L9.19995 1.59734L10.7973 0Z'
															fill='#2B2A2F'
														/>
													</svg>
												</div>
											</div>
											{shouldShowRating && (
												<div className='star-ratings'>
													{renderStars(rating, brandTag)}
													<div className='star-ratings-int'>{rating}</div>
												</div>
											)}
										</div>
										<div className='product-info-container'>
											<div>
												<div className='wine-info'>
													<p className='info'>
														<strong> Wine Style:</strong>{' '}
														{activeSubProduct?.referencedProduct?.styleName ||
															[]}
													</p>
													<p className='info'>
														<strong>Grape:</strong>{' '}
														{activeSubProduct?.referencedProduct?.grapeName ||
															[]}
													</p>
												</div>
												<div className='wine-info'>
													<p className='info'>
														<strong>Country:</strong>{' '}
														{activeSubProduct?.referencedProduct?.countryName ||
															[]}
													</p>
													<p className='info'>
														<strong>Region:</strong>{' '}
														{activeSubProduct?.referencedProduct?.regionName ||
															[]}
													</p>
												</div>
											</div>
											<div
												className='wine-description'
												dangerouslySetInnerHTML={{
													__html:
														activeSubProduct?.referencedProduct?.description ||
														'',
												}}
											></div>
											<div className='wine-profile'>
												{isMobile ? (
													<>
														{(tastingNoteShort || foodPairing) && (
															<div
																className='show-more'
																onClick={toggleProfile}
															>
																<span className='show-more-text'>
																	{isExpanded ? 'Show less' : 'Show more'}
																</span>
																<svg
																	xmlns='http://www.w3.org/2000/svg'
																	width='20'
																	height='20'
																	viewBox='0 0 20 20'
																	fill='none'
																	className='chevron'
																>
																	<path
																		d='M3.57141 7.14284L9.99998 13.5714L16.4286 7.14284'
																		stroke='#2B2A2F'
																		strokeWidth='2'
																	/>
																</svg>
															</div>
														)}

														{isExpanded && (
															<>
																{tastingNoteShort && (
																	<>
																		<strong>Flavor Profile</strong>
																		<p
																			dangerouslySetInnerHTML={{
																				__html: tastingNoteShort,
																			}}
																		></p>
																	</>
																)}
															</>
														)}
													</>
												) : (
													<>
														{tastingNoteShort && (
															<>
																<strong>Flavor Profile</strong>
																<p
																	dangerouslySetInnerHTML={{
																		__html: tastingNoteShort,
																	}}
																></p>
															</>
														)}
													</>
												)}
											</div>

											{foodPairing && (
												<div className='food-pairing'>
													{isMobile ? (
														<>
															{isExpanded && (
																<>
																	<strong>Food Pairings</strong>
																	<p
																		dangerouslySetInnerHTML={{
																			__html: foodPairing || '',
																		}}
																	></p>
																</>
															)}
														</>
													) : (
														<>
															<strong>Food Pairings</strong>
															<p
																dangerouslySetInnerHTML={{
																	__html: foodPairing || '',
																}}
															></p>
														</>
													)}
												</div>
											)}

											<div className='product-button-container'>
												<ProductButton
													text={isPresell ? 'PREORDER NOW' : 'ORDER NOW'}
													className='case-tabs-product-button'
													voucherCopy={voucherCopy}
												/>
											</div>
										</div>
									</div>
									{products[activeProductIndex]?.mixed === true &&
										caseData?.contentProducts?.length > 1 && (
											<Pagination>
												<button
													className='pagination-button'
													onClick={handlePreviousSubProduct}
													disabled={currentSubProductIndex === 0}
												>
													<img
														src='/images/us/common/icons/wsj/angle_left_black.svg'
														alt='Previous'
													/>
												</button>

												{pageNumbers}

												<button
													className='pagination-button'
													onClick={handleNextSubProduct}
													disabled={
														currentSubProductIndex ===
														validContentProducts.length - 1
													}
												>
													<img
														src='/images/us/common/icons/wsj/angle_right_black.svg'
														alt='Next'
													/>
												</button>
											</Pagination>
										)}
								</ProductDetails>
							</>
						) : (
							<p>No sub-products available for this product.</p>
						)}
					</div>
					{products[activeProductIndex]?.mixed === true &&
						caseData?.contentProducts?.length > 1 && (
							<svg
								onClick={handleNextSubProduct}
								xmlns='http://www.w3.org/2000/svg'
								width='40'
								height='40'
								viewBox='0 0 40 40'
								fill='none'
								style={{ cursor: 'pointer', marginBottom: '100px' }}
								className='desktop-svg'
							>
								<path
									fillRule='evenodd'
									clipRule='evenodd'
									d='M10.7973 0L30.7973 20L10.7973 40L9.19995 38.4027L27.6026 20L9.19995 1.59734L10.7973 0Z'
									fill='#2B2A2F'
								/>
							</svg>
						)}
				</div>
			</CarouselContainer>
		</SectionContainer>
	);
};

export { CaseTabsSection };
